import { PayloadAction, createSlice } from '@reduxjs/toolkit';


type ItemType = {
  id: number,
  report: string,
  name: string,
  associated_department: number,
  notification_reason: string,
  date_informed_at: string | null,
  is_deleted: boolean,
  has_error?: boolean
};

type InformedIndividualState = {
  items: Array<ItemType>,
  loading: boolean,
  page: number,
  specialPage: number,
  count: number,
  next: string | null,
  previous: string | null
};
const initialState: InformedIndividualState = {
  items: [],
  page: 1,
  specialPage: 0,
  loading: true,
  count: 0,
  next: null,
  previous: null,
};

export const informedIndividualSlice = createSlice({
  name: 'informedIndividuals',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<Array<ItemType>>) => {
      state.items = action.payload;
    },
    setSpecialPage: (state, action: PayloadAction<number>) => {
      state.specialPage = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setNext: (state, action: PayloadAction<string | null>) => {
      state.next = action.payload;
    },
    setPrevious: (state, action: PayloadAction<string | null>) => {
      state.previous = action.payload;
    },
    setCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItems,
  setNext,
  setPrevious,
  setLoading,
  setPage,
  setSpecialPage,
  setCount,
} = informedIndividualSlice.actions;

export default informedIndividualSlice.reducer;